import type { SupSingleVaultV3 } from "@/types";

import React from "react";
import { SupTracker } from "@repo/core-ui";

interface GridCellVaultTypeProps {
  singleVault: SupSingleVaultV3;
}

export default function GridCellVaultType({ singleVault }: GridCellVaultTypeProps) {
  const label = singleVault.recommend_vault_share_withdrawal ? "Multi-Step" : "Standard";
  const variant = singleVault.recommend_vault_share_withdrawal ? "info" : "primary";

  return <SupTracker variant={variant}>{label}</SupTracker>;
}
